import {string, type} from 'io-ts';
import {HttpClient, POST, expectOneOf} from '~/library/network-facade';

const AccountClosureResponse = type({
    uuid: string,
    message: string,
});

export const accountClosureGet = (http: HttpClient) =>
    http('v1/private/user/account_closure').then(
        expectOneOf({
            200: AccountClosureResponse,
            400: null,
            401: null,
        })
    );

export const accountClosurePost = (http: HttpClient, data: {uuid: string; code: string}) => {
    return http('v1/private/user/account_closure', POST(data)).then(
        expectOneOf({
            200: null,
            400: null,
            401: null,
        })
    );
};
